import { call, put, select } from 'redux-saga/effects';
import { getMyData } from '@bitComponents/adabyron/client';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export const composeI3Object = (ip3gResponse) => {
  const i3DssObj = ip3gResponse || {};
  /* HASHES QUE INTERPRETAMOS */
  const i3Z = i3DssObj.z ? i3DssObj.z : '';
  const i3C = i3DssObj.c ? i3DssObj.c : '';
  const i3L = i3DssObj.l ? i3DssObj.l : '';
  const i3P = i3DssObj.p ? i3DssObj.p : '';

  /* MAPEO A CONTEXT */
  return {
    userCUCFijoHash: i3C,
    userCUCMovilHash: i3L,
    userCUCPrepagoHash: i3P,
    userIdPartyHash: i3Z,
  };
};
export const tranformXcol2Ip3Hashes = (xcol = '') => {
  let res = xcol;
  try {
    res = window && window.atob(res.split('.')[1]);
    res = JSON.parse(res);
    res = composeI3Object(res);
  } catch (error) {
    res = composeI3Object({});
  }
  return res;
};


const normalizeGetClientData = (response) => {
  const { xcol } = response;
  const { userIdPartyHash } = tranformXcol2Ip3Hashes(xcol);
  return {
    ...response,
    userIdPartyHash,
  };
};

export function* getClientData(params) {
  const { reduxUpdate, normalizeHttpErrors } = params;

  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(getMyData, { onlyMobilePhone: true }, context);
    const getClientDataNormalized = normalizeGetClientData(response);
    yield put(successUpdate(getClientDataNormalized));
    return getClientDataNormalized;
  } catch (error) {
    console.log(error);
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_MY_DATA, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
